import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Invoiceregister = () => {
  const [invoiceregister, setInvoiceregister] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`invoiceregister?page=${page}`);
      setInvoiceregister(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`invoiceregister/${id}`);
      setInvoiceregister(
        invoiceregister.filter((invoiceregister) => invoiceregister.id !== id),
      );
    }
  };
  return (
    <Wrapper pageTitle={"Invoice Register"}>
      <InnerNav
        createLink={"/invoiceregisterCreate"}
        listLink={"/invoiceregister"}
      />
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Invoice date </th>
                <th className="px-4 py-3">Client </th>
                <th className="px-4 py-3">Invoice no </th>
                <th className="px-4 py-3">Invoiced amount </th>
                <th className="px-4 py-3">Amount paid </th>
                <th className="px-4 py-3">Balance Amount </th>
                <th className="px-4 py-3">Invoice type </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {invoiceregister?.map((invoiceregister) => {
                return (
                  <tr
                    key={invoiceregister.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{invoiceregister.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.invoice_date}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.client.name}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.invoice_no}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.invoiced_amount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.amount_paid}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.balance_amount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {invoiceregister.invoice_type}
                    </td>
                    <td className="flex px-4 py-3 text-sm">
                      <Link
                        className="btn btn-sm btn-outline-secondary px-5"
                        to={`/invoiceregister/${invoiceregister.id}/edit`}
                      >
                        <AiFillEdit />{" "}
                      </Link>
                      <span
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => del(invoiceregister.id)}
                      >
                        {" "}
                        <AiFillDelete className="text-rose-500 text-lg" />
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Invoiceregister;
